/**
 * @fileoverview gRPC-Web generated client stub for 
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');



const proto = require('./api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.OmmuseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.OmmusePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetHealthCheckRequest,
 *   !proto.GetHealthCheckResponse>}
 */
const methodDescriptor_Ommuse_GetHealthCheck = new grpc.web.MethodDescriptor(
  '/Ommuse/GetHealthCheck',
  grpc.web.MethodType.UNARY,
  proto.GetHealthCheckRequest,
  proto.GetHealthCheckResponse,
  /**
   * @param {!proto.GetHealthCheckRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetHealthCheckResponse.deserializeBinary
);


/**
 * @param {!proto.GetHealthCheckRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetHealthCheckResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetHealthCheckResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getHealthCheck =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetHealthCheck',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetHealthCheck,
      callback);
};


/**
 * @param {!proto.GetHealthCheckRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetHealthCheckResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getHealthCheck =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetHealthCheck',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetHealthCheck);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.RegisterUserRequest,
 *   !proto.RegisterUserResponse>}
 */
const methodDescriptor_Ommuse_RegisterUser = new grpc.web.MethodDescriptor(
  '/Ommuse/RegisterUser',
  grpc.web.MethodType.UNARY,
  proto.RegisterUserRequest,
  proto.RegisterUserResponse,
  /**
   * @param {!proto.RegisterUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.RegisterUserResponse.deserializeBinary
);


/**
 * @param {!proto.RegisterUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.RegisterUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.RegisterUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.registerUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/RegisterUser',
      request,
      metadata || {},
      methodDescriptor_Ommuse_RegisterUser,
      callback);
};


/**
 * @param {!proto.RegisterUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.RegisterUserResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.registerUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/RegisterUser',
      request,
      metadata || {},
      methodDescriptor_Ommuse_RegisterUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.RegisterUserWalletRequest,
 *   !proto.RegisterUserWalletResponse>}
 */
const methodDescriptor_Ommuse_RegisterUserWallet = new grpc.web.MethodDescriptor(
  '/Ommuse/RegisterUserWallet',
  grpc.web.MethodType.UNARY,
  proto.RegisterUserWalletRequest,
  proto.RegisterUserWalletResponse,
  /**
   * @param {!proto.RegisterUserWalletRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.RegisterUserWalletResponse.deserializeBinary
);


/**
 * @param {!proto.RegisterUserWalletRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.RegisterUserWalletResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.RegisterUserWalletResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.registerUserWallet =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/RegisterUserWallet',
      request,
      metadata || {},
      methodDescriptor_Ommuse_RegisterUserWallet,
      callback);
};


/**
 * @param {!proto.RegisterUserWalletRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.RegisterUserWalletResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.registerUserWallet =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/RegisterUserWallet',
      request,
      metadata || {},
      methodDescriptor_Ommuse_RegisterUserWallet);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetUserRequest,
 *   !proto.GetUserResponse>}
 */
const methodDescriptor_Ommuse_GetPublicUser = new grpc.web.MethodDescriptor(
  '/Ommuse/GetPublicUser',
  grpc.web.MethodType.UNARY,
  proto.GetUserRequest,
  proto.GetUserResponse,
  /**
   * @param {!proto.GetUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetUserResponse.deserializeBinary
);


/**
 * @param {!proto.GetUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getPublicUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetPublicUser',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetPublicUser,
      callback);
};


/**
 * @param {!proto.GetUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetUserResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getPublicUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetPublicUser',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetPublicUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetUserRequest,
 *   !proto.GetUserResponse>}
 */
const methodDescriptor_Ommuse_GetUser = new grpc.web.MethodDescriptor(
  '/Ommuse/GetUser',
  grpc.web.MethodType.UNARY,
  proto.GetUserRequest,
  proto.GetUserResponse,
  /**
   * @param {!proto.GetUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetUserResponse.deserializeBinary
);


/**
 * @param {!proto.GetUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetUser',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetUser,
      callback);
};


/**
 * @param {!proto.GetUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetUserResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetUser',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetUsernamesRequest,
 *   !proto.GetUsernamesResponse>}
 */
const methodDescriptor_Ommuse_GetUsernames = new grpc.web.MethodDescriptor(
  '/Ommuse/GetUsernames',
  grpc.web.MethodType.UNARY,
  proto.GetUsernamesRequest,
  proto.GetUsernamesResponse,
  /**
   * @param {!proto.GetUsernamesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetUsernamesResponse.deserializeBinary
);


/**
 * @param {!proto.GetUsernamesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetUsernamesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetUsernamesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getUsernames =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetUsernames',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetUsernames,
      callback);
};


/**
 * @param {!proto.GetUsernamesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetUsernamesResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getUsernames =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetUsernames',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetUsernames);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetS3CredentialsRequest,
 *   !proto.GetS3CredentialsResponse>}
 */
const methodDescriptor_Ommuse_GetS3Credentials = new grpc.web.MethodDescriptor(
  '/Ommuse/GetS3Credentials',
  grpc.web.MethodType.UNARY,
  proto.GetS3CredentialsRequest,
  proto.GetS3CredentialsResponse,
  /**
   * @param {!proto.GetS3CredentialsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetS3CredentialsResponse.deserializeBinary
);


/**
 * @param {!proto.GetS3CredentialsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetS3CredentialsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetS3CredentialsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getS3Credentials =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetS3Credentials',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetS3Credentials,
      callback);
};


/**
 * @param {!proto.GetS3CredentialsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetS3CredentialsResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getS3Credentials =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetS3Credentials',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetS3Credentials);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.PostSkillsRequest,
 *   !proto.PostSkillsResponse>}
 */
const methodDescriptor_Ommuse_PostSkills = new grpc.web.MethodDescriptor(
  '/Ommuse/PostSkills',
  grpc.web.MethodType.UNARY,
  proto.PostSkillsRequest,
  proto.PostSkillsResponse,
  /**
   * @param {!proto.PostSkillsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.PostSkillsResponse.deserializeBinary
);


/**
 * @param {!proto.PostSkillsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.PostSkillsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.PostSkillsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.postSkills =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/PostSkills',
      request,
      metadata || {},
      methodDescriptor_Ommuse_PostSkills,
      callback);
};


/**
 * @param {!proto.PostSkillsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.PostSkillsResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.postSkills =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/PostSkills',
      request,
      metadata || {},
      methodDescriptor_Ommuse_PostSkills);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.PostTransactionRequest,
 *   !proto.PostTransactionResponse>}
 */
const methodDescriptor_Ommuse_PostTransaction = new grpc.web.MethodDescriptor(
  '/Ommuse/PostTransaction',
  grpc.web.MethodType.UNARY,
  proto.PostTransactionRequest,
  proto.PostTransactionResponse,
  /**
   * @param {!proto.PostTransactionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.PostTransactionResponse.deserializeBinary
);


/**
 * @param {!proto.PostTransactionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.PostTransactionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.PostTransactionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.postTransaction =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/PostTransaction',
      request,
      metadata || {},
      methodDescriptor_Ommuse_PostTransaction,
      callback);
};


/**
 * @param {!proto.PostTransactionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.PostTransactionResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.postTransaction =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/PostTransaction',
      request,
      metadata || {},
      methodDescriptor_Ommuse_PostTransaction);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetTrackRequest,
 *   !proto.GetTrackResponse>}
 */
const methodDescriptor_Ommuse_GetTrack = new grpc.web.MethodDescriptor(
  '/Ommuse/GetTrack',
  grpc.web.MethodType.UNARY,
  proto.GetTrackRequest,
  proto.GetTrackResponse,
  /**
   * @param {!proto.GetTrackRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetTrackResponse.deserializeBinary
);


/**
 * @param {!proto.GetTrackRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetTrackResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetTrackResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getTrack =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetTrack',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetTrack,
      callback);
};


/**
 * @param {!proto.GetTrackRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetTrackResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getTrack =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetTrack',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetTrack);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetTrackVersionRequest,
 *   !proto.GetTrackVersionResponse>}
 */
const methodDescriptor_Ommuse_GetTrackVersion = new grpc.web.MethodDescriptor(
  '/Ommuse/GetTrackVersion',
  grpc.web.MethodType.UNARY,
  proto.GetTrackVersionRequest,
  proto.GetTrackVersionResponse,
  /**
   * @param {!proto.GetTrackVersionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetTrackVersionResponse.deserializeBinary
);


/**
 * @param {!proto.GetTrackVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetTrackVersionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetTrackVersionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getTrackVersion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetTrackVersion',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetTrackVersion,
      callback);
};


/**
 * @param {!proto.GetTrackVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetTrackVersionResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getTrackVersion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetTrackVersion',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetTrackVersion);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.DeleteTrackVersionRequest,
 *   !proto.DeleteTrackVersionResponse>}
 */
const methodDescriptor_Ommuse_DeleteTrackVersion = new grpc.web.MethodDescriptor(
  '/Ommuse/DeleteTrackVersion',
  grpc.web.MethodType.UNARY,
  proto.DeleteTrackVersionRequest,
  proto.DeleteTrackVersionResponse,
  /**
   * @param {!proto.DeleteTrackVersionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.DeleteTrackVersionResponse.deserializeBinary
);


/**
 * @param {!proto.DeleteTrackVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.DeleteTrackVersionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.DeleteTrackVersionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.deleteTrackVersion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/DeleteTrackVersion',
      request,
      metadata || {},
      methodDescriptor_Ommuse_DeleteTrackVersion,
      callback);
};


/**
 * @param {!proto.DeleteTrackVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.DeleteTrackVersionResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.deleteTrackVersion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/DeleteTrackVersion',
      request,
      metadata || {},
      methodDescriptor_Ommuse_DeleteTrackVersion);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetTrackVersionsRequest,
 *   !proto.GetTrackVersionsResponse>}
 */
const methodDescriptor_Ommuse_GetTrackVersions = new grpc.web.MethodDescriptor(
  '/Ommuse/GetTrackVersions',
  grpc.web.MethodType.UNARY,
  proto.GetTrackVersionsRequest,
  proto.GetTrackVersionsResponse,
  /**
   * @param {!proto.GetTrackVersionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetTrackVersionsResponse.deserializeBinary
);


/**
 * @param {!proto.GetTrackVersionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetTrackVersionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetTrackVersionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getTrackVersions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetTrackVersions',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetTrackVersions,
      callback);
};


/**
 * @param {!proto.GetTrackVersionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetTrackVersionsResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getTrackVersions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetTrackVersions',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetTrackVersions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetUserTrackVersionsRequest,
 *   !proto.GetUserTrackVersionsResponse>}
 */
const methodDescriptor_Ommuse_GetUserTrackVersions = new grpc.web.MethodDescriptor(
  '/Ommuse/GetUserTrackVersions',
  grpc.web.MethodType.UNARY,
  proto.GetUserTrackVersionsRequest,
  proto.GetUserTrackVersionsResponse,
  /**
   * @param {!proto.GetUserTrackVersionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetUserTrackVersionsResponse.deserializeBinary
);


/**
 * @param {!proto.GetUserTrackVersionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetUserTrackVersionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetUserTrackVersionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getUserTrackVersions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetUserTrackVersions',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetUserTrackVersions,
      callback);
};


/**
 * @param {!proto.GetUserTrackVersionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetUserTrackVersionsResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getUserTrackVersions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetUserTrackVersions',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetUserTrackVersions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.DeleteTrackFileRequest,
 *   !proto.DeleteTrackFileResponse>}
 */
const methodDescriptor_Ommuse_DeleteTrackFile = new grpc.web.MethodDescriptor(
  '/Ommuse/DeleteTrackFile',
  grpc.web.MethodType.UNARY,
  proto.DeleteTrackFileRequest,
  proto.DeleteTrackFileResponse,
  /**
   * @param {!proto.DeleteTrackFileRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.DeleteTrackFileResponse.deserializeBinary
);


/**
 * @param {!proto.DeleteTrackFileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.DeleteTrackFileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.DeleteTrackFileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.deleteTrackFile =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/DeleteTrackFile',
      request,
      metadata || {},
      methodDescriptor_Ommuse_DeleteTrackFile,
      callback);
};


/**
 * @param {!proto.DeleteTrackFileRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.DeleteTrackFileResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.deleteTrackFile =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/DeleteTrackFile',
      request,
      metadata || {},
      methodDescriptor_Ommuse_DeleteTrackFile);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetTrackFileRequest,
 *   !proto.GetTrackFileResponse>}
 */
const methodDescriptor_Ommuse_GetTrackFile = new grpc.web.MethodDescriptor(
  '/Ommuse/GetTrackFile',
  grpc.web.MethodType.UNARY,
  proto.GetTrackFileRequest,
  proto.GetTrackFileResponse,
  /**
   * @param {!proto.GetTrackFileRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetTrackFileResponse.deserializeBinary
);


/**
 * @param {!proto.GetTrackFileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetTrackFileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetTrackFileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getTrackFile =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetTrackFile',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetTrackFile,
      callback);
};


/**
 * @param {!proto.GetTrackFileRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetTrackFileResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getTrackFile =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetTrackFile',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetTrackFile);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetTrackFilesRequest,
 *   !proto.GetTrackFilesResponse>}
 */
const methodDescriptor_Ommuse_GetTrackFiles = new grpc.web.MethodDescriptor(
  '/Ommuse/GetTrackFiles',
  grpc.web.MethodType.UNARY,
  proto.GetTrackFilesRequest,
  proto.GetTrackFilesResponse,
  /**
   * @param {!proto.GetTrackFilesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetTrackFilesResponse.deserializeBinary
);


/**
 * @param {!proto.GetTrackFilesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetTrackFilesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetTrackFilesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getTrackFiles =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetTrackFiles',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetTrackFiles,
      callback);
};


/**
 * @param {!proto.GetTrackFilesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetTrackFilesResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getTrackFiles =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetTrackFiles',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetTrackFiles);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.DeleteFolderRequest,
 *   !proto.DeleteFolderResponse>}
 */
const methodDescriptor_Ommuse_DeleteFolder = new grpc.web.MethodDescriptor(
  '/Ommuse/DeleteFolder',
  grpc.web.MethodType.UNARY,
  proto.DeleteFolderRequest,
  proto.DeleteFolderResponse,
  /**
   * @param {!proto.DeleteFolderRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.DeleteFolderResponse.deserializeBinary
);


/**
 * @param {!proto.DeleteFolderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.DeleteFolderResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.DeleteFolderResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.deleteFolder =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/DeleteFolder',
      request,
      metadata || {},
      methodDescriptor_Ommuse_DeleteFolder,
      callback);
};


/**
 * @param {!proto.DeleteFolderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.DeleteFolderResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.deleteFolder =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/DeleteFolder',
      request,
      metadata || {},
      methodDescriptor_Ommuse_DeleteFolder);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetFolderRequest,
 *   !proto.GetFolderResponse>}
 */
const methodDescriptor_Ommuse_GetFolder = new grpc.web.MethodDescriptor(
  '/Ommuse/GetFolder',
  grpc.web.MethodType.UNARY,
  proto.GetFolderRequest,
  proto.GetFolderResponse,
  /**
   * @param {!proto.GetFolderRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetFolderResponse.deserializeBinary
);


/**
 * @param {!proto.GetFolderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetFolderResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetFolderResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getFolder =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetFolder',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetFolder,
      callback);
};


/**
 * @param {!proto.GetFolderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetFolderResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getFolder =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetFolder',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetFolder);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetFoldersRequest,
 *   !proto.GetFoldersResponse>}
 */
const methodDescriptor_Ommuse_GetFolders = new grpc.web.MethodDescriptor(
  '/Ommuse/GetFolders',
  grpc.web.MethodType.UNARY,
  proto.GetFoldersRequest,
  proto.GetFoldersResponse,
  /**
   * @param {!proto.GetFoldersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetFoldersResponse.deserializeBinary
);


/**
 * @param {!proto.GetFoldersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetFoldersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetFoldersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getFolders =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetFolders',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetFolders,
      callback);
};


/**
 * @param {!proto.GetFoldersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetFoldersResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getFolders =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetFolders',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetFolders);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.PostFolderRequest,
 *   !proto.PostFolderResponse>}
 */
const methodDescriptor_Ommuse_PostFolder = new grpc.web.MethodDescriptor(
  '/Ommuse/PostFolder',
  grpc.web.MethodType.UNARY,
  proto.PostFolderRequest,
  proto.PostFolderResponse,
  /**
   * @param {!proto.PostFolderRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.PostFolderResponse.deserializeBinary
);


/**
 * @param {!proto.PostFolderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.PostFolderResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.PostFolderResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.postFolder =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/PostFolder',
      request,
      metadata || {},
      methodDescriptor_Ommuse_PostFolder,
      callback);
};


/**
 * @param {!proto.PostFolderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.PostFolderResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.postFolder =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/PostFolder',
      request,
      metadata || {},
      methodDescriptor_Ommuse_PostFolder);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetTracksRequest,
 *   !proto.GetTracksResponse>}
 */
const methodDescriptor_Ommuse_GetTracks = new grpc.web.MethodDescriptor(
  '/Ommuse/GetTracks',
  grpc.web.MethodType.UNARY,
  proto.GetTracksRequest,
  proto.GetTracksResponse,
  /**
   * @param {!proto.GetTracksRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetTracksResponse.deserializeBinary
);


/**
 * @param {!proto.GetTracksRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetTracksResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetTracksResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getTracks =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetTracks',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetTracks,
      callback);
};


/**
 * @param {!proto.GetTracksRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetTracksResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getTracks =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetTracks',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetTracks);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetMyTracksRequest,
 *   !proto.GetMyTracksResponse>}
 */
const methodDescriptor_Ommuse_GetMyTracks = new grpc.web.MethodDescriptor(
  '/Ommuse/GetMyTracks',
  grpc.web.MethodType.UNARY,
  proto.GetMyTracksRequest,
  proto.GetMyTracksResponse,
  /**
   * @param {!proto.GetMyTracksRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetMyTracksResponse.deserializeBinary
);


/**
 * @param {!proto.GetMyTracksRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetMyTracksResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetMyTracksResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getMyTracks =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetMyTracks',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetMyTracks,
      callback);
};


/**
 * @param {!proto.GetMyTracksRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetMyTracksResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getMyTracks =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetMyTracks',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetMyTracks);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetPublishedTracksRequest,
 *   !proto.GetPublishedTracksResponse>}
 */
const methodDescriptor_Ommuse_GetPublishedTracks = new grpc.web.MethodDescriptor(
  '/Ommuse/GetPublishedTracks',
  grpc.web.MethodType.UNARY,
  proto.GetPublishedTracksRequest,
  proto.GetPublishedTracksResponse,
  /**
   * @param {!proto.GetPublishedTracksRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetPublishedTracksResponse.deserializeBinary
);


/**
 * @param {!proto.GetPublishedTracksRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetPublishedTracksResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetPublishedTracksResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getPublishedTracks =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetPublishedTracks',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetPublishedTracks,
      callback);
};


/**
 * @param {!proto.GetPublishedTracksRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetPublishedTracksResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getPublishedTracks =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetPublishedTracks',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetPublishedTracks);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.PostTrackRequest,
 *   !proto.PostTrackResponse>}
 */
const methodDescriptor_Ommuse_PostTrack = new grpc.web.MethodDescriptor(
  '/Ommuse/PostTrack',
  grpc.web.MethodType.UNARY,
  proto.PostTrackRequest,
  proto.PostTrackResponse,
  /**
   * @param {!proto.PostTrackRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.PostTrackResponse.deserializeBinary
);


/**
 * @param {!proto.PostTrackRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.PostTrackResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.PostTrackResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.postTrack =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/PostTrack',
      request,
      metadata || {},
      methodDescriptor_Ommuse_PostTrack,
      callback);
};


/**
 * @param {!proto.PostTrackRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.PostTrackResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.postTrack =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/PostTrack',
      request,
      metadata || {},
      methodDescriptor_Ommuse_PostTrack);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.PostTrackBatchRequest,
 *   !proto.PostTrackBatchResponse>}
 */
const methodDescriptor_Ommuse_PostTrackBatch = new grpc.web.MethodDescriptor(
  '/Ommuse/PostTrackBatch',
  grpc.web.MethodType.UNARY,
  proto.PostTrackBatchRequest,
  proto.PostTrackBatchResponse,
  /**
   * @param {!proto.PostTrackBatchRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.PostTrackBatchResponse.deserializeBinary
);


/**
 * @param {!proto.PostTrackBatchRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.PostTrackBatchResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.PostTrackBatchResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.postTrackBatch =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/PostTrackBatch',
      request,
      metadata || {},
      methodDescriptor_Ommuse_PostTrackBatch,
      callback);
};


/**
 * @param {!proto.PostTrackBatchRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.PostTrackBatchResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.postTrackBatch =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/PostTrackBatch',
      request,
      metadata || {},
      methodDescriptor_Ommuse_PostTrackBatch);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.PostTrackVersionRequest,
 *   !proto.PostTrackVersionResponse>}
 */
const methodDescriptor_Ommuse_PostTrackVersion = new grpc.web.MethodDescriptor(
  '/Ommuse/PostTrackVersion',
  grpc.web.MethodType.UNARY,
  proto.PostTrackVersionRequest,
  proto.PostTrackVersionResponse,
  /**
   * @param {!proto.PostTrackVersionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.PostTrackVersionResponse.deserializeBinary
);


/**
 * @param {!proto.PostTrackVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.PostTrackVersionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.PostTrackVersionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.postTrackVersion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/PostTrackVersion',
      request,
      metadata || {},
      methodDescriptor_Ommuse_PostTrackVersion,
      callback);
};


/**
 * @param {!proto.PostTrackVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.PostTrackVersionResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.postTrackVersion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/PostTrackVersion',
      request,
      metadata || {},
      methodDescriptor_Ommuse_PostTrackVersion);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.PostTrackFileRequest,
 *   !proto.PostTrackFileResponse>}
 */
const methodDescriptor_Ommuse_PostTrackFile = new grpc.web.MethodDescriptor(
  '/Ommuse/PostTrackFile',
  grpc.web.MethodType.UNARY,
  proto.PostTrackFileRequest,
  proto.PostTrackFileResponse,
  /**
   * @param {!proto.PostTrackFileRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.PostTrackFileResponse.deserializeBinary
);


/**
 * @param {!proto.PostTrackFileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.PostTrackFileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.PostTrackFileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.postTrackFile =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/PostTrackFile',
      request,
      metadata || {},
      methodDescriptor_Ommuse_PostTrackFile,
      callback);
};


/**
 * @param {!proto.PostTrackFileRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.PostTrackFileResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.postTrackFile =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/PostTrackFile',
      request,
      metadata || {},
      methodDescriptor_Ommuse_PostTrackFile);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.QuerySkillsGenresRequest,
 *   !proto.QuerySkillsGenresResponse>}
 */
const methodDescriptor_Ommuse_QuerySkillsGenres = new grpc.web.MethodDescriptor(
  '/Ommuse/QuerySkillsGenres',
  grpc.web.MethodType.UNARY,
  proto.QuerySkillsGenresRequest,
  proto.QuerySkillsGenresResponse,
  /**
   * @param {!proto.QuerySkillsGenresRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.QuerySkillsGenresResponse.deserializeBinary
);


/**
 * @param {!proto.QuerySkillsGenresRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.QuerySkillsGenresResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.QuerySkillsGenresResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.querySkillsGenres =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/QuerySkillsGenres',
      request,
      metadata || {},
      methodDescriptor_Ommuse_QuerySkillsGenres,
      callback);
};


/**
 * @param {!proto.QuerySkillsGenresRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.QuerySkillsGenresResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.querySkillsGenres =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/QuerySkillsGenres',
      request,
      metadata || {},
      methodDescriptor_Ommuse_QuerySkillsGenres);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.QueryTransactionsRequest,
 *   !proto.QueryTransactionsResponse>}
 */
const methodDescriptor_Ommuse_QueryTransactions = new grpc.web.MethodDescriptor(
  '/Ommuse/QueryTransactions',
  grpc.web.MethodType.UNARY,
  proto.QueryTransactionsRequest,
  proto.QueryTransactionsResponse,
  /**
   * @param {!proto.QueryTransactionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.QueryTransactionsResponse.deserializeBinary
);


/**
 * @param {!proto.QueryTransactionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.QueryTransactionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.QueryTransactionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.queryTransactions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/QueryTransactions',
      request,
      metadata || {},
      methodDescriptor_Ommuse_QueryTransactions,
      callback);
};


/**
 * @param {!proto.QueryTransactionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.QueryTransactionsResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.queryTransactions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/QueryTransactions',
      request,
      metadata || {},
      methodDescriptor_Ommuse_QueryTransactions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.SendInviteRequest,
 *   !proto.SendInviteResponse>}
 */
const methodDescriptor_Ommuse_SendInvite = new grpc.web.MethodDescriptor(
  '/Ommuse/SendInvite',
  grpc.web.MethodType.UNARY,
  proto.SendInviteRequest,
  proto.SendInviteResponse,
  /**
   * @param {!proto.SendInviteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.SendInviteResponse.deserializeBinary
);


/**
 * @param {!proto.SendInviteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.SendInviteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.SendInviteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.sendInvite =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/SendInvite',
      request,
      metadata || {},
      methodDescriptor_Ommuse_SendInvite,
      callback);
};


/**
 * @param {!proto.SendInviteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.SendInviteResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.sendInvite =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/SendInvite',
      request,
      metadata || {},
      methodDescriptor_Ommuse_SendInvite);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetAllTimeStorageUsageRequest,
 *   !proto.GetAllTimeStorageUsageResponse>}
 */
const methodDescriptor_Ommuse_GetAllTimeStorageUsage = new grpc.web.MethodDescriptor(
  '/Ommuse/GetAllTimeStorageUsage',
  grpc.web.MethodType.UNARY,
  proto.GetAllTimeStorageUsageRequest,
  proto.GetAllTimeStorageUsageResponse,
  /**
   * @param {!proto.GetAllTimeStorageUsageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetAllTimeStorageUsageResponse.deserializeBinary
);


/**
 * @param {!proto.GetAllTimeStorageUsageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetAllTimeStorageUsageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetAllTimeStorageUsageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getAllTimeStorageUsage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetAllTimeStorageUsage',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetAllTimeStorageUsage,
      callback);
};


/**
 * @param {!proto.GetAllTimeStorageUsageRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetAllTimeStorageUsageResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getAllTimeStorageUsage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetAllTimeStorageUsage',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetAllTimeStorageUsage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.PostUserSubscriptionRequest,
 *   !proto.PostUserSubscriptionResponse>}
 */
const methodDescriptor_Ommuse_PostUserSubscription = new grpc.web.MethodDescriptor(
  '/Ommuse/PostUserSubscription',
  grpc.web.MethodType.UNARY,
  proto.PostUserSubscriptionRequest,
  proto.PostUserSubscriptionResponse,
  /**
   * @param {!proto.PostUserSubscriptionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.PostUserSubscriptionResponse.deserializeBinary
);


/**
 * @param {!proto.PostUserSubscriptionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.PostUserSubscriptionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.PostUserSubscriptionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.postUserSubscription =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/PostUserSubscription',
      request,
      metadata || {},
      methodDescriptor_Ommuse_PostUserSubscription,
      callback);
};


/**
 * @param {!proto.PostUserSubscriptionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.PostUserSubscriptionResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.postUserSubscription =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/PostUserSubscription',
      request,
      metadata || {},
      methodDescriptor_Ommuse_PostUserSubscription);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.IncrementMasteringUsageRequest,
 *   !proto.IncrementMasteringUsageResponse>}
 */
const methodDescriptor_Ommuse_IncrementMasteringUsage = new grpc.web.MethodDescriptor(
  '/Ommuse/IncrementMasteringUsage',
  grpc.web.MethodType.UNARY,
  proto.IncrementMasteringUsageRequest,
  proto.IncrementMasteringUsageResponse,
  /**
   * @param {!proto.IncrementMasteringUsageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.IncrementMasteringUsageResponse.deserializeBinary
);


/**
 * @param {!proto.IncrementMasteringUsageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.IncrementMasteringUsageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.IncrementMasteringUsageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.incrementMasteringUsage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/IncrementMasteringUsage',
      request,
      metadata || {},
      methodDescriptor_Ommuse_IncrementMasteringUsage,
      callback);
};


/**
 * @param {!proto.IncrementMasteringUsageRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.IncrementMasteringUsageResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.incrementMasteringUsage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/IncrementMasteringUsage',
      request,
      metadata || {},
      methodDescriptor_Ommuse_IncrementMasteringUsage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.IncrementMintingUsageRequest,
 *   !proto.IncrementMintingUsageResponse>}
 */
const methodDescriptor_Ommuse_IncrementMintingUsage = new grpc.web.MethodDescriptor(
  '/Ommuse/IncrementMintingUsage',
  grpc.web.MethodType.UNARY,
  proto.IncrementMintingUsageRequest,
  proto.IncrementMintingUsageResponse,
  /**
   * @param {!proto.IncrementMintingUsageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.IncrementMintingUsageResponse.deserializeBinary
);


/**
 * @param {!proto.IncrementMintingUsageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.IncrementMintingUsageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.IncrementMintingUsageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.incrementMintingUsage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/IncrementMintingUsage',
      request,
      metadata || {},
      methodDescriptor_Ommuse_IncrementMintingUsage,
      callback);
};


/**
 * @param {!proto.IncrementMintingUsageRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.IncrementMintingUsageResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.incrementMintingUsage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/IncrementMintingUsage',
      request,
      metadata || {},
      methodDescriptor_Ommuse_IncrementMintingUsage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.HasPaymentMethodRequest,
 *   !proto.HasPaymentMethodResponse>}
 */
const methodDescriptor_Ommuse_HasPaymentMethod = new grpc.web.MethodDescriptor(
  '/Ommuse/HasPaymentMethod',
  grpc.web.MethodType.UNARY,
  proto.HasPaymentMethodRequest,
  proto.HasPaymentMethodResponse,
  /**
   * @param {!proto.HasPaymentMethodRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.HasPaymentMethodResponse.deserializeBinary
);


/**
 * @param {!proto.HasPaymentMethodRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.HasPaymentMethodResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.HasPaymentMethodResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.hasPaymentMethod =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/HasPaymentMethod',
      request,
      metadata || {},
      methodDescriptor_Ommuse_HasPaymentMethod,
      callback);
};


/**
 * @param {!proto.HasPaymentMethodRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.HasPaymentMethodResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.hasPaymentMethod =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/HasPaymentMethod',
      request,
      metadata || {},
      methodDescriptor_Ommuse_HasPaymentMethod);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.RegisterInitialUserRequest,
 *   !proto.RegisterInitialUserResponse>}
 */
const methodDescriptor_Ommuse_RegisterInitialUser = new grpc.web.MethodDescriptor(
  '/Ommuse/RegisterInitialUser',
  grpc.web.MethodType.UNARY,
  proto.RegisterInitialUserRequest,
  proto.RegisterInitialUserResponse,
  /**
   * @param {!proto.RegisterInitialUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.RegisterInitialUserResponse.deserializeBinary
);


/**
 * @param {!proto.RegisterInitialUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.RegisterInitialUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.RegisterInitialUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.registerInitialUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/RegisterInitialUser',
      request,
      metadata || {},
      methodDescriptor_Ommuse_RegisterInitialUser,
      callback);
};


/**
 * @param {!proto.RegisterInitialUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.RegisterInitialUserResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.registerInitialUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/RegisterInitialUser',
      request,
      metadata || {},
      methodDescriptor_Ommuse_RegisterInitialUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.RegisterMinorSubscriptionRequest,
 *   !proto.RegisterMinorSubscriptionResponse>}
 */
const methodDescriptor_Ommuse_RegisterMinorSubscription = new grpc.web.MethodDescriptor(
  '/Ommuse/RegisterMinorSubscription',
  grpc.web.MethodType.UNARY,
  proto.RegisterMinorSubscriptionRequest,
  proto.RegisterMinorSubscriptionResponse,
  /**
   * @param {!proto.RegisterMinorSubscriptionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.RegisterMinorSubscriptionResponse.deserializeBinary
);


/**
 * @param {!proto.RegisterMinorSubscriptionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.RegisterMinorSubscriptionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.RegisterMinorSubscriptionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.registerMinorSubscription =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/RegisterMinorSubscription',
      request,
      metadata || {},
      methodDescriptor_Ommuse_RegisterMinorSubscription,
      callback);
};


/**
 * @param {!proto.RegisterMinorSubscriptionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.RegisterMinorSubscriptionResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.registerMinorSubscription =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/RegisterMinorSubscription',
      request,
      metadata || {},
      methodDescriptor_Ommuse_RegisterMinorSubscription);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.RegisterMajorTrialSubscriptionRequest,
 *   !proto.RegisterMajorTrialSubscriptionResponse>}
 */
const methodDescriptor_Ommuse_RegisterMajorTrialSubscription = new grpc.web.MethodDescriptor(
  '/Ommuse/RegisterMajorTrialSubscription',
  grpc.web.MethodType.UNARY,
  proto.RegisterMajorTrialSubscriptionRequest,
  proto.RegisterMajorTrialSubscriptionResponse,
  /**
   * @param {!proto.RegisterMajorTrialSubscriptionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.RegisterMajorTrialSubscriptionResponse.deserializeBinary
);


/**
 * @param {!proto.RegisterMajorTrialSubscriptionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.RegisterMajorTrialSubscriptionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.RegisterMajorTrialSubscriptionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.registerMajorTrialSubscription =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/RegisterMajorTrialSubscription',
      request,
      metadata || {},
      methodDescriptor_Ommuse_RegisterMajorTrialSubscription,
      callback);
};


/**
 * @param {!proto.RegisterMajorTrialSubscriptionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.RegisterMajorTrialSubscriptionResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.registerMajorTrialSubscription =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/RegisterMajorTrialSubscription',
      request,
      metadata || {},
      methodDescriptor_Ommuse_RegisterMajorTrialSubscription);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GlobalSearchRequest,
 *   !proto.GlobalSearchResponse>}
 */
const methodDescriptor_Ommuse_GlobalSearch = new grpc.web.MethodDescriptor(
  '/Ommuse/GlobalSearch',
  grpc.web.MethodType.UNARY,
  proto.GlobalSearchRequest,
  proto.GlobalSearchResponse,
  /**
   * @param {!proto.GlobalSearchRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GlobalSearchResponse.deserializeBinary
);


/**
 * @param {!proto.GlobalSearchRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GlobalSearchResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GlobalSearchResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.globalSearch =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GlobalSearch',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GlobalSearch,
      callback);
};


/**
 * @param {!proto.GlobalSearchRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GlobalSearchResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.globalSearch =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GlobalSearch',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GlobalSearch);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetAssetSizeRequest,
 *   !proto.GetAssetSizeResponse>}
 */
const methodDescriptor_Ommuse_GetAssetSize = new grpc.web.MethodDescriptor(
  '/Ommuse/GetAssetSize',
  grpc.web.MethodType.UNARY,
  proto.GetAssetSizeRequest,
  proto.GetAssetSizeResponse,
  /**
   * @param {!proto.GetAssetSizeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetAssetSizeResponse.deserializeBinary
);


/**
 * @param {!proto.GetAssetSizeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetAssetSizeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetAssetSizeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getAssetSize =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetAssetSize',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetAssetSize,
      callback);
};


/**
 * @param {!proto.GetAssetSizeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetAssetSizeResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getAssetSize =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetAssetSize',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetAssetSize);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetTutorialStateRequest,
 *   !proto.GetTutorialStateResponse>}
 */
const methodDescriptor_Ommuse_GetTutorialState = new grpc.web.MethodDescriptor(
  '/Ommuse/GetTutorialState',
  grpc.web.MethodType.UNARY,
  proto.GetTutorialStateRequest,
  proto.GetTutorialStateResponse,
  /**
   * @param {!proto.GetTutorialStateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetTutorialStateResponse.deserializeBinary
);


/**
 * @param {!proto.GetTutorialStateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetTutorialStateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetTutorialStateResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getTutorialState =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetTutorialState',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetTutorialState,
      callback);
};


/**
 * @param {!proto.GetTutorialStateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetTutorialStateResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getTutorialState =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetTutorialState',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetTutorialState);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetTutorialStatesRequest,
 *   !proto.GetTutorialStatesResponse>}
 */
const methodDescriptor_Ommuse_GetTutorialStates = new grpc.web.MethodDescriptor(
  '/Ommuse/GetTutorialStates',
  grpc.web.MethodType.UNARY,
  proto.GetTutorialStatesRequest,
  proto.GetTutorialStatesResponse,
  /**
   * @param {!proto.GetTutorialStatesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetTutorialStatesResponse.deserializeBinary
);


/**
 * @param {!proto.GetTutorialStatesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetTutorialStatesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetTutorialStatesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getTutorialStates =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetTutorialStates',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetTutorialStates,
      callback);
};


/**
 * @param {!proto.GetTutorialStatesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetTutorialStatesResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getTutorialStates =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetTutorialStates',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetTutorialStates);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.PostTutorialStateRequest,
 *   !proto.PostTutorialStateResponse>}
 */
const methodDescriptor_Ommuse_PostTutorialState = new grpc.web.MethodDescriptor(
  '/Ommuse/PostTutorialState',
  grpc.web.MethodType.UNARY,
  proto.PostTutorialStateRequest,
  proto.PostTutorialStateResponse,
  /**
   * @param {!proto.PostTutorialStateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.PostTutorialStateResponse.deserializeBinary
);


/**
 * @param {!proto.PostTutorialStateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.PostTutorialStateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.PostTutorialStateResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.postTutorialState =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/PostTutorialState',
      request,
      metadata || {},
      methodDescriptor_Ommuse_PostTutorialState,
      callback);
};


/**
 * @param {!proto.PostTutorialStateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.PostTutorialStateResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.postTutorialState =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/PostTutorialState',
      request,
      metadata || {},
      methodDescriptor_Ommuse_PostTutorialState);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.PostPromotionCodeRequest,
 *   !proto.PostPromotionCodeResponse>}
 */
const methodDescriptor_Ommuse_PostPromotionCode = new grpc.web.MethodDescriptor(
  '/Ommuse/PostPromotionCode',
  grpc.web.MethodType.UNARY,
  proto.PostPromotionCodeRequest,
  proto.PostPromotionCodeResponse,
  /**
   * @param {!proto.PostPromotionCodeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.PostPromotionCodeResponse.deserializeBinary
);


/**
 * @param {!proto.PostPromotionCodeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.PostPromotionCodeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.PostPromotionCodeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.postPromotionCode =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/PostPromotionCode',
      request,
      metadata || {},
      methodDescriptor_Ommuse_PostPromotionCode,
      callback);
};


/**
 * @param {!proto.PostPromotionCodeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.PostPromotionCodeResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.postPromotionCode =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/PostPromotionCode',
      request,
      metadata || {},
      methodDescriptor_Ommuse_PostPromotionCode);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.PostResendVerificationEmailRequest,
 *   !proto.PostResendVerificationEmailResponse>}
 */
const methodDescriptor_Ommuse_PostResendVerificationEmail = new grpc.web.MethodDescriptor(
  '/Ommuse/PostResendVerificationEmail',
  grpc.web.MethodType.UNARY,
  proto.PostResendVerificationEmailRequest,
  proto.PostResendVerificationEmailResponse,
  /**
   * @param {!proto.PostResendVerificationEmailRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.PostResendVerificationEmailResponse.deserializeBinary
);


/**
 * @param {!proto.PostResendVerificationEmailRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.PostResendVerificationEmailResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.PostResendVerificationEmailResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.postResendVerificationEmail =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/PostResendVerificationEmail',
      request,
      metadata || {},
      methodDescriptor_Ommuse_PostResendVerificationEmail,
      callback);
};


/**
 * @param {!proto.PostResendVerificationEmailRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.PostResendVerificationEmailResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.postResendVerificationEmail =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/PostResendVerificationEmail',
      request,
      metadata || {},
      methodDescriptor_Ommuse_PostResendVerificationEmail);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.PostShareRequest,
 *   !proto.PostShareResponse>}
 */
const methodDescriptor_Ommuse_PostShare = new grpc.web.MethodDescriptor(
  '/Ommuse/PostShare',
  grpc.web.MethodType.UNARY,
  proto.PostShareRequest,
  proto.PostShareResponse,
  /**
   * @param {!proto.PostShareRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.PostShareResponse.deserializeBinary
);


/**
 * @param {!proto.PostShareRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.PostShareResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.PostShareResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.postShare =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/PostShare',
      request,
      metadata || {},
      methodDescriptor_Ommuse_PostShare,
      callback);
};


/**
 * @param {!proto.PostShareRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.PostShareResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.postShare =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/PostShare',
      request,
      metadata || {},
      methodDescriptor_Ommuse_PostShare);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetShareRequest,
 *   !proto.GetShareResponse>}
 */
const methodDescriptor_Ommuse_GetShare = new grpc.web.MethodDescriptor(
  '/Ommuse/GetShare',
  grpc.web.MethodType.UNARY,
  proto.GetShareRequest,
  proto.GetShareResponse,
  /**
   * @param {!proto.GetShareRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetShareResponse.deserializeBinary
);


/**
 * @param {!proto.GetShareRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetShareResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetShareResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getShare =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetShare',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetShare,
      callback);
};


/**
 * @param {!proto.GetShareRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetShareResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getShare =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetShare',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetShare);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetSharesRequest,
 *   !proto.GetSharesResponse>}
 */
const methodDescriptor_Ommuse_GetShares = new grpc.web.MethodDescriptor(
  '/Ommuse/GetShares',
  grpc.web.MethodType.UNARY,
  proto.GetSharesRequest,
  proto.GetSharesResponse,
  /**
   * @param {!proto.GetSharesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetSharesResponse.deserializeBinary
);


/**
 * @param {!proto.GetSharesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetSharesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetSharesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getShares =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetShares',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetShares,
      callback);
};


/**
 * @param {!proto.GetSharesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetSharesResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getShares =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetShares',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetShares);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetShareAccessTokenRequest,
 *   !proto.GetShareAccessTokenResponse>}
 */
const methodDescriptor_Ommuse_GetShareAccessToken = new grpc.web.MethodDescriptor(
  '/Ommuse/GetShareAccessToken',
  grpc.web.MethodType.UNARY,
  proto.GetShareAccessTokenRequest,
  proto.GetShareAccessTokenResponse,
  /**
   * @param {!proto.GetShareAccessTokenRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetShareAccessTokenResponse.deserializeBinary
);


/**
 * @param {!proto.GetShareAccessTokenRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetShareAccessTokenResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetShareAccessTokenResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getShareAccessToken =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetShareAccessToken',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetShareAccessToken,
      callback);
};


/**
 * @param {!proto.GetShareAccessTokenRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetShareAccessTokenResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getShareAccessToken =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetShareAccessToken',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetShareAccessToken);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.DeleteShareRequest,
 *   !proto.DeleteShareResponse>}
 */
const methodDescriptor_Ommuse_DeleteShare = new grpc.web.MethodDescriptor(
  '/Ommuse/DeleteShare',
  grpc.web.MethodType.UNARY,
  proto.DeleteShareRequest,
  proto.DeleteShareResponse,
  /**
   * @param {!proto.DeleteShareRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.DeleteShareResponse.deserializeBinary
);


/**
 * @param {!proto.DeleteShareRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.DeleteShareResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.DeleteShareResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.deleteShare =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/DeleteShare',
      request,
      metadata || {},
      methodDescriptor_Ommuse_DeleteShare,
      callback);
};


/**
 * @param {!proto.DeleteShareRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.DeleteShareResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.deleteShare =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/DeleteShare',
      request,
      metadata || {},
      methodDescriptor_Ommuse_DeleteShare);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.PostShareImpressionRequest,
 *   !proto.PostShareImpressionResponse>}
 */
const methodDescriptor_Ommuse_PostShareImpression = new grpc.web.MethodDescriptor(
  '/Ommuse/PostShareImpression',
  grpc.web.MethodType.UNARY,
  proto.PostShareImpressionRequest,
  proto.PostShareImpressionResponse,
  /**
   * @param {!proto.PostShareImpressionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.PostShareImpressionResponse.deserializeBinary
);


/**
 * @param {!proto.PostShareImpressionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.PostShareImpressionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.PostShareImpressionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.postShareImpression =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/PostShareImpression',
      request,
      metadata || {},
      methodDescriptor_Ommuse_PostShareImpression,
      callback);
};


/**
 * @param {!proto.PostShareImpressionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.PostShareImpressionResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.postShareImpression =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/PostShareImpression',
      request,
      metadata || {},
      methodDescriptor_Ommuse_PostShareImpression);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetUsersRequest,
 *   !proto.GetUsersResponse>}
 */
const methodDescriptor_Ommuse_GetUsers = new grpc.web.MethodDescriptor(
  '/Ommuse/GetUsers',
  grpc.web.MethodType.UNARY,
  proto.GetUsersRequest,
  proto.GetUsersResponse,
  /**
   * @param {!proto.GetUsersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetUsersResponse.deserializeBinary
);


/**
 * @param {!proto.GetUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetUsersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetUsersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getUsers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetUsers',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetUsers,
      callback);
};


/**
 * @param {!proto.GetUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetUsersResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getUsers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetUsers',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetUsers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetArtistsForUserOfTracksRequest,
 *   !proto.GetArtistsForUserOfTracksResponse>}
 */
const methodDescriptor_Ommuse_GetArtistsForUserOfTracks = new grpc.web.MethodDescriptor(
  '/Ommuse/GetArtistsForUserOfTracks',
  grpc.web.MethodType.UNARY,
  proto.GetArtistsForUserOfTracksRequest,
  proto.GetArtistsForUserOfTracksResponse,
  /**
   * @param {!proto.GetArtistsForUserOfTracksRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetArtistsForUserOfTracksResponse.deserializeBinary
);


/**
 * @param {!proto.GetArtistsForUserOfTracksRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetArtistsForUserOfTracksResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetArtistsForUserOfTracksResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getArtistsForUserOfTracks =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetArtistsForUserOfTracks',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetArtistsForUserOfTracks,
      callback);
};


/**
 * @param {!proto.GetArtistsForUserOfTracksRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetArtistsForUserOfTracksResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getArtistsForUserOfTracks =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetArtistsForUserOfTracks',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetArtistsForUserOfTracks);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetCollaboratorsForUserOfTracksRequest,
 *   !proto.GetCollaboratorsForUserOfTracksResponse>}
 */
const methodDescriptor_Ommuse_GetCollaboratorsForUserOfTracks = new grpc.web.MethodDescriptor(
  '/Ommuse/GetCollaboratorsForUserOfTracks',
  grpc.web.MethodType.UNARY,
  proto.GetCollaboratorsForUserOfTracksRequest,
  proto.GetCollaboratorsForUserOfTracksResponse,
  /**
   * @param {!proto.GetCollaboratorsForUserOfTracksRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetCollaboratorsForUserOfTracksResponse.deserializeBinary
);


/**
 * @param {!proto.GetCollaboratorsForUserOfTracksRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetCollaboratorsForUserOfTracksResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetCollaboratorsForUserOfTracksResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getCollaboratorsForUserOfTracks =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetCollaboratorsForUserOfTracks',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetCollaboratorsForUserOfTracks,
      callback);
};


/**
 * @param {!proto.GetCollaboratorsForUserOfTracksRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetCollaboratorsForUserOfTracksResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getCollaboratorsForUserOfTracks =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetCollaboratorsForUserOfTracks',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetCollaboratorsForUserOfTracks);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.AddEventRequest,
 *   !proto.AddEventResponse>}
 */
const methodDescriptor_Ommuse_AddEvent = new grpc.web.MethodDescriptor(
  '/Ommuse/AddEvent',
  grpc.web.MethodType.UNARY,
  proto.AddEventRequest,
  proto.AddEventResponse,
  /**
   * @param {!proto.AddEventRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.AddEventResponse.deserializeBinary
);


/**
 * @param {!proto.AddEventRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.AddEventResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.AddEventResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.addEvent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/AddEvent',
      request,
      metadata || {},
      methodDescriptor_Ommuse_AddEvent,
      callback);
};


/**
 * @param {!proto.AddEventRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.AddEventResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.addEvent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/AddEvent',
      request,
      metadata || {},
      methodDescriptor_Ommuse_AddEvent);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetUserEventsRequest,
 *   !proto.GetUserEventsResponse>}
 */
const methodDescriptor_Ommuse_GetUserEvents = new grpc.web.MethodDescriptor(
  '/Ommuse/GetUserEvents',
  grpc.web.MethodType.UNARY,
  proto.GetUserEventsRequest,
  proto.GetUserEventsResponse,
  /**
   * @param {!proto.GetUserEventsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetUserEventsResponse.deserializeBinary
);


/**
 * @param {!proto.GetUserEventsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetUserEventsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetUserEventsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getUserEvents =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetUserEvents',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetUserEvents,
      callback);
};


/**
 * @param {!proto.GetUserEventsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetUserEventsResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getUserEvents =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetUserEvents',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetUserEvents);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.UpdateUserEventRequest,
 *   !proto.UpdateUserEventResponse>}
 */
const methodDescriptor_Ommuse_UpdateUserEvent = new grpc.web.MethodDescriptor(
  '/Ommuse/UpdateUserEvent',
  grpc.web.MethodType.UNARY,
  proto.UpdateUserEventRequest,
  proto.UpdateUserEventResponse,
  /**
   * @param {!proto.UpdateUserEventRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.UpdateUserEventResponse.deserializeBinary
);


/**
 * @param {!proto.UpdateUserEventRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.UpdateUserEventResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.UpdateUserEventResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.updateUserEvent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/UpdateUserEvent',
      request,
      metadata || {},
      methodDescriptor_Ommuse_UpdateUserEvent,
      callback);
};


/**
 * @param {!proto.UpdateUserEventRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.UpdateUserEventResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.updateUserEvent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/UpdateUserEvent',
      request,
      metadata || {},
      methodDescriptor_Ommuse_UpdateUserEvent);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.SearchRequest,
 *   !proto.SearchResponse>}
 */
const methodDescriptor_Ommuse_Search = new grpc.web.MethodDescriptor(
  '/Ommuse/Search',
  grpc.web.MethodType.UNARY,
  proto.SearchRequest,
  proto.SearchResponse,
  /**
   * @param {!proto.SearchRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.SearchResponse.deserializeBinary
);


/**
 * @param {!proto.SearchRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.SearchResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.SearchResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.search =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/Search',
      request,
      metadata || {},
      methodDescriptor_Ommuse_Search,
      callback);
};


/**
 * @param {!proto.SearchRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.SearchResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.search =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/Search',
      request,
      metadata || {},
      methodDescriptor_Ommuse_Search);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.DeleteUserRequest,
 *   !proto.DeleteUserResponse>}
 */
const methodDescriptor_Ommuse_DeleteUser = new grpc.web.MethodDescriptor(
  '/Ommuse/DeleteUser',
  grpc.web.MethodType.UNARY,
  proto.DeleteUserRequest,
  proto.DeleteUserResponse,
  /**
   * @param {!proto.DeleteUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.DeleteUserResponse.deserializeBinary
);


/**
 * @param {!proto.DeleteUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.DeleteUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.DeleteUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.deleteUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/DeleteUser',
      request,
      metadata || {},
      methodDescriptor_Ommuse_DeleteUser,
      callback);
};


/**
 * @param {!proto.DeleteUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.DeleteUserResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.deleteUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/DeleteUser',
      request,
      metadata || {},
      methodDescriptor_Ommuse_DeleteUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.UpdateTrackPositionRequest,
 *   !proto.UpdateTrackPositionResponse>}
 */
const methodDescriptor_Ommuse_UpdateTrackPosition = new grpc.web.MethodDescriptor(
  '/Ommuse/UpdateTrackPosition',
  grpc.web.MethodType.UNARY,
  proto.UpdateTrackPositionRequest,
  proto.UpdateTrackPositionResponse,
  /**
   * @param {!proto.UpdateTrackPositionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.UpdateTrackPositionResponse.deserializeBinary
);


/**
 * @param {!proto.UpdateTrackPositionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.UpdateTrackPositionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.UpdateTrackPositionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.updateTrackPosition =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/UpdateTrackPosition',
      request,
      metadata || {},
      methodDescriptor_Ommuse_UpdateTrackPosition,
      callback);
};


/**
 * @param {!proto.UpdateTrackPositionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.UpdateTrackPositionResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.updateTrackPosition =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/UpdateTrackPosition',
      request,
      metadata || {},
      methodDescriptor_Ommuse_UpdateTrackPosition);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.CreateProjectRequest,
 *   !proto.CreateProjectResponse>}
 */
const methodDescriptor_Ommuse_CreateProject = new grpc.web.MethodDescriptor(
  '/Ommuse/CreateProject',
  grpc.web.MethodType.UNARY,
  proto.CreateProjectRequest,
  proto.CreateProjectResponse,
  /**
   * @param {!proto.CreateProjectRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.CreateProjectResponse.deserializeBinary
);


/**
 * @param {!proto.CreateProjectRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.CreateProjectResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.CreateProjectResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.createProject =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/CreateProject',
      request,
      metadata || {},
      methodDescriptor_Ommuse_CreateProject,
      callback);
};


/**
 * @param {!proto.CreateProjectRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.CreateProjectResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.createProject =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/CreateProject',
      request,
      metadata || {},
      methodDescriptor_Ommuse_CreateProject);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.UpdateProjectRequest,
 *   !proto.UpdateProjectResponse>}
 */
const methodDescriptor_Ommuse_UpdateProject = new grpc.web.MethodDescriptor(
  '/Ommuse/UpdateProject',
  grpc.web.MethodType.UNARY,
  proto.UpdateProjectRequest,
  proto.UpdateProjectResponse,
  /**
   * @param {!proto.UpdateProjectRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.UpdateProjectResponse.deserializeBinary
);


/**
 * @param {!proto.UpdateProjectRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.UpdateProjectResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.UpdateProjectResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.updateProject =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/UpdateProject',
      request,
      metadata || {},
      methodDescriptor_Ommuse_UpdateProject,
      callback);
};


/**
 * @param {!proto.UpdateProjectRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.UpdateProjectResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.updateProject =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/UpdateProject',
      request,
      metadata || {},
      methodDescriptor_Ommuse_UpdateProject);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.AddCollaboratorsToProjectsRequest,
 *   !proto.AddCollaboratorsToProjectsResponse>}
 */
const methodDescriptor_Ommuse_AddCollaboratorsToProjects = new grpc.web.MethodDescriptor(
  '/Ommuse/AddCollaboratorsToProjects',
  grpc.web.MethodType.UNARY,
  proto.AddCollaboratorsToProjectsRequest,
  proto.AddCollaboratorsToProjectsResponse,
  /**
   * @param {!proto.AddCollaboratorsToProjectsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.AddCollaboratorsToProjectsResponse.deserializeBinary
);


/**
 * @param {!proto.AddCollaboratorsToProjectsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.AddCollaboratorsToProjectsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.AddCollaboratorsToProjectsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.addCollaboratorsToProjects =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/AddCollaboratorsToProjects',
      request,
      metadata || {},
      methodDescriptor_Ommuse_AddCollaboratorsToProjects,
      callback);
};


/**
 * @param {!proto.AddCollaboratorsToProjectsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.AddCollaboratorsToProjectsResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.addCollaboratorsToProjects =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/AddCollaboratorsToProjects',
      request,
      metadata || {},
      methodDescriptor_Ommuse_AddCollaboratorsToProjects);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetProjectsRequest,
 *   !proto.GetProjectsResponse>}
 */
const methodDescriptor_Ommuse_GetProjects = new grpc.web.MethodDescriptor(
  '/Ommuse/GetProjects',
  grpc.web.MethodType.UNARY,
  proto.GetProjectsRequest,
  proto.GetProjectsResponse,
  /**
   * @param {!proto.GetProjectsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetProjectsResponse.deserializeBinary
);


/**
 * @param {!proto.GetProjectsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetProjectsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetProjectsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getProjects =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetProjects',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetProjects,
      callback);
};


/**
 * @param {!proto.GetProjectsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetProjectsResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getProjects =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetProjects',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetProjects);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetEnterpriseAllUsersRequest,
 *   !proto.GetEnterpriseAllUsersResponse>}
 */
const methodDescriptor_Ommuse_GetEnterpriseAllUsers = new grpc.web.MethodDescriptor(
  '/Ommuse/GetEnterpriseAllUsers',
  grpc.web.MethodType.UNARY,
  proto.GetEnterpriseAllUsersRequest,
  proto.GetEnterpriseAllUsersResponse,
  /**
   * @param {!proto.GetEnterpriseAllUsersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetEnterpriseAllUsersResponse.deserializeBinary
);


/**
 * @param {!proto.GetEnterpriseAllUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetEnterpriseAllUsersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetEnterpriseAllUsersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getEnterpriseAllUsers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetEnterpriseAllUsers',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetEnterpriseAllUsers,
      callback);
};


/**
 * @param {!proto.GetEnterpriseAllUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetEnterpriseAllUsersResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getEnterpriseAllUsers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetEnterpriseAllUsers',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetEnterpriseAllUsers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetEnterprisesForUserRequest,
 *   !proto.GetEnterprisesForUserResponse>}
 */
const methodDescriptor_Ommuse_GetEnterprisesForUser = new grpc.web.MethodDescriptor(
  '/Ommuse/GetEnterprisesForUser',
  grpc.web.MethodType.UNARY,
  proto.GetEnterprisesForUserRequest,
  proto.GetEnterprisesForUserResponse,
  /**
   * @param {!proto.GetEnterprisesForUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetEnterprisesForUserResponse.deserializeBinary
);


/**
 * @param {!proto.GetEnterprisesForUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetEnterprisesForUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetEnterprisesForUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getEnterprisesForUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetEnterprisesForUser',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetEnterprisesForUser,
      callback);
};


/**
 * @param {!proto.GetEnterprisesForUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetEnterprisesForUserResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getEnterprisesForUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetEnterprisesForUser',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetEnterprisesForUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.PostProjectFilesBatchRequest,
 *   !proto.PostProjectFilesBatchResponse>}
 */
const methodDescriptor_Ommuse_PostProjectFilesBatch = new grpc.web.MethodDescriptor(
  '/Ommuse/PostProjectFilesBatch',
  grpc.web.MethodType.UNARY,
  proto.PostProjectFilesBatchRequest,
  proto.PostProjectFilesBatchResponse,
  /**
   * @param {!proto.PostProjectFilesBatchRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.PostProjectFilesBatchResponse.deserializeBinary
);


/**
 * @param {!proto.PostProjectFilesBatchRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.PostProjectFilesBatchResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.PostProjectFilesBatchResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.postProjectFilesBatch =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/PostProjectFilesBatch',
      request,
      metadata || {},
      methodDescriptor_Ommuse_PostProjectFilesBatch,
      callback);
};


/**
 * @param {!proto.PostProjectFilesBatchRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.PostProjectFilesBatchResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.postProjectFilesBatch =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/PostProjectFilesBatch',
      request,
      metadata || {},
      methodDescriptor_Ommuse_PostProjectFilesBatch);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetProjectFilesRequest,
 *   !proto.GetProjectFilesResponse>}
 */
const methodDescriptor_Ommuse_GetProjectFiles = new grpc.web.MethodDescriptor(
  '/Ommuse/GetProjectFiles',
  grpc.web.MethodType.UNARY,
  proto.GetProjectFilesRequest,
  proto.GetProjectFilesResponse,
  /**
   * @param {!proto.GetProjectFilesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetProjectFilesResponse.deserializeBinary
);


/**
 * @param {!proto.GetProjectFilesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetProjectFilesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetProjectFilesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getProjectFiles =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetProjectFiles',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetProjectFiles,
      callback);
};


/**
 * @param {!proto.GetProjectFilesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetProjectFilesResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getProjectFiles =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetProjectFiles',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetProjectFiles);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetProjectRequest,
 *   !proto.GetProjectResponse>}
 */
const methodDescriptor_Ommuse_GetProject = new grpc.web.MethodDescriptor(
  '/Ommuse/GetProject',
  grpc.web.MethodType.UNARY,
  proto.GetProjectRequest,
  proto.GetProjectResponse,
  /**
   * @param {!proto.GetProjectRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetProjectResponse.deserializeBinary
);


/**
 * @param {!proto.GetProjectRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetProjectResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetProjectResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getProject =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetProject',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetProject,
      callback);
};


/**
 * @param {!proto.GetProjectRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetProjectResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getProject =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetProject',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetProject);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetProjectTrackImagesRequest,
 *   !proto.GetProjectTrackImagesResponse>}
 */
const methodDescriptor_Ommuse_GetProjectTrackImages = new grpc.web.MethodDescriptor(
  '/Ommuse/GetProjectTrackImages',
  grpc.web.MethodType.UNARY,
  proto.GetProjectTrackImagesRequest,
  proto.GetProjectTrackImagesResponse,
  /**
   * @param {!proto.GetProjectTrackImagesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetProjectTrackImagesResponse.deserializeBinary
);


/**
 * @param {!proto.GetProjectTrackImagesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetProjectTrackImagesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetProjectTrackImagesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getProjectTrackImages =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetProjectTrackImages',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetProjectTrackImages,
      callback);
};


/**
 * @param {!proto.GetProjectTrackImagesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetProjectTrackImagesResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getProjectTrackImages =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetProjectTrackImages',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetProjectTrackImages);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.UpdateProjectFilesRequest,
 *   !proto.UpdateProjectFilesResponse>}
 */
const methodDescriptor_Ommuse_UpdateProjectFiles = new grpc.web.MethodDescriptor(
  '/Ommuse/UpdateProjectFiles',
  grpc.web.MethodType.UNARY,
  proto.UpdateProjectFilesRequest,
  proto.UpdateProjectFilesResponse,
  /**
   * @param {!proto.UpdateProjectFilesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.UpdateProjectFilesResponse.deserializeBinary
);


/**
 * @param {!proto.UpdateProjectFilesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.UpdateProjectFilesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.UpdateProjectFilesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.updateProjectFiles =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/UpdateProjectFiles',
      request,
      metadata || {},
      methodDescriptor_Ommuse_UpdateProjectFiles,
      callback);
};


/**
 * @param {!proto.UpdateProjectFilesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.UpdateProjectFilesResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.updateProjectFiles =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/UpdateProjectFiles',
      request,
      metadata || {},
      methodDescriptor_Ommuse_UpdateProjectFiles);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.UpdateSplitSheetDetailsRequest,
 *   !proto.UpdateSplitSheetDetailsResponse>}
 */
const methodDescriptor_Ommuse_UpdateSplitSheetDetails = new grpc.web.MethodDescriptor(
  '/Ommuse/UpdateSplitSheetDetails',
  grpc.web.MethodType.UNARY,
  proto.UpdateSplitSheetDetailsRequest,
  proto.UpdateSplitSheetDetailsResponse,
  /**
   * @param {!proto.UpdateSplitSheetDetailsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.UpdateSplitSheetDetailsResponse.deserializeBinary
);


/**
 * @param {!proto.UpdateSplitSheetDetailsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.UpdateSplitSheetDetailsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.UpdateSplitSheetDetailsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.updateSplitSheetDetails =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/UpdateSplitSheetDetails',
      request,
      metadata || {},
      methodDescriptor_Ommuse_UpdateSplitSheetDetails,
      callback);
};


/**
 * @param {!proto.UpdateSplitSheetDetailsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.UpdateSplitSheetDetailsResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.updateSplitSheetDetails =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/UpdateSplitSheetDetails',
      request,
      metadata || {},
      methodDescriptor_Ommuse_UpdateSplitSheetDetails);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.AddMemberToEnterpriseRequest,
 *   !proto.AddMemberToEnterpriseResponse>}
 */
const methodDescriptor_Ommuse_AddMemberToEnterprise = new grpc.web.MethodDescriptor(
  '/Ommuse/AddMemberToEnterprise',
  grpc.web.MethodType.UNARY,
  proto.AddMemberToEnterpriseRequest,
  proto.AddMemberToEnterpriseResponse,
  /**
   * @param {!proto.AddMemberToEnterpriseRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.AddMemberToEnterpriseResponse.deserializeBinary
);


/**
 * @param {!proto.AddMemberToEnterpriseRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.AddMemberToEnterpriseResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.AddMemberToEnterpriseResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.addMemberToEnterprise =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/AddMemberToEnterprise',
      request,
      metadata || {},
      methodDescriptor_Ommuse_AddMemberToEnterprise,
      callback);
};


/**
 * @param {!proto.AddMemberToEnterpriseRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.AddMemberToEnterpriseResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.addMemberToEnterprise =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/AddMemberToEnterprise',
      request,
      metadata || {},
      methodDescriptor_Ommuse_AddMemberToEnterprise);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.UpdateMemberOfEnterpriseRequest,
 *   !proto.UpdateMemberOfEnterpriseResponse>}
 */
const methodDescriptor_Ommuse_UpdateMemberOfEnterprise = new grpc.web.MethodDescriptor(
  '/Ommuse/UpdateMemberOfEnterprise',
  grpc.web.MethodType.UNARY,
  proto.UpdateMemberOfEnterpriseRequest,
  proto.UpdateMemberOfEnterpriseResponse,
  /**
   * @param {!proto.UpdateMemberOfEnterpriseRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.UpdateMemberOfEnterpriseResponse.deserializeBinary
);


/**
 * @param {!proto.UpdateMemberOfEnterpriseRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.UpdateMemberOfEnterpriseResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.UpdateMemberOfEnterpriseResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.updateMemberOfEnterprise =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/UpdateMemberOfEnterprise',
      request,
      metadata || {},
      methodDescriptor_Ommuse_UpdateMemberOfEnterprise,
      callback);
};


/**
 * @param {!proto.UpdateMemberOfEnterpriseRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.UpdateMemberOfEnterpriseResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.updateMemberOfEnterprise =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/UpdateMemberOfEnterprise',
      request,
      metadata || {},
      methodDescriptor_Ommuse_UpdateMemberOfEnterprise);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.DeleteEnterpriseMemberRequest,
 *   !proto.DeleteEnterpriseMemberResponse>}
 */
const methodDescriptor_Ommuse_DeleteEnterpriseMember = new grpc.web.MethodDescriptor(
  '/Ommuse/DeleteEnterpriseMember',
  grpc.web.MethodType.UNARY,
  proto.DeleteEnterpriseMemberRequest,
  proto.DeleteEnterpriseMemberResponse,
  /**
   * @param {!proto.DeleteEnterpriseMemberRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.DeleteEnterpriseMemberResponse.deserializeBinary
);


/**
 * @param {!proto.DeleteEnterpriseMemberRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.DeleteEnterpriseMemberResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.DeleteEnterpriseMemberResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.deleteEnterpriseMember =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/DeleteEnterpriseMember',
      request,
      metadata || {},
      methodDescriptor_Ommuse_DeleteEnterpriseMember,
      callback);
};


/**
 * @param {!proto.DeleteEnterpriseMemberRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.DeleteEnterpriseMemberResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.deleteEnterpriseMember =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/DeleteEnterpriseMember',
      request,
      metadata || {},
      methodDescriptor_Ommuse_DeleteEnterpriseMember);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.UpdateLastActiveRequest,
 *   !proto.UpdateLastActiveResponse>}
 */
const methodDescriptor_Ommuse_UpdateLastActive = new grpc.web.MethodDescriptor(
  '/Ommuse/UpdateLastActive',
  grpc.web.MethodType.UNARY,
  proto.UpdateLastActiveRequest,
  proto.UpdateLastActiveResponse,
  /**
   * @param {!proto.UpdateLastActiveRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.UpdateLastActiveResponse.deserializeBinary
);


/**
 * @param {!proto.UpdateLastActiveRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.UpdateLastActiveResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.UpdateLastActiveResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.updateLastActive =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/UpdateLastActive',
      request,
      metadata || {},
      methodDescriptor_Ommuse_UpdateLastActive,
      callback);
};


/**
 * @param {!proto.UpdateLastActiveRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.UpdateLastActiveResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.updateLastActive =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/UpdateLastActive',
      request,
      metadata || {},
      methodDescriptor_Ommuse_UpdateLastActive);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.UpdateLastActiveRequest,
 *   !proto.UpdateLastActiveResponse>}
 */
const methodDescriptor_Ommuse_AcceptEnterpriseAddendum = new grpc.web.MethodDescriptor(
  '/Ommuse/AcceptEnterpriseAddendum',
  grpc.web.MethodType.UNARY,
  proto.UpdateLastActiveRequest,
  proto.UpdateLastActiveResponse,
  /**
   * @param {!proto.UpdateLastActiveRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.UpdateLastActiveResponse.deserializeBinary
);


/**
 * @param {!proto.UpdateLastActiveRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.UpdateLastActiveResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.UpdateLastActiveResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.acceptEnterpriseAddendum =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/AcceptEnterpriseAddendum',
      request,
      metadata || {},
      methodDescriptor_Ommuse_AcceptEnterpriseAddendum,
      callback);
};


/**
 * @param {!proto.UpdateLastActiveRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.UpdateLastActiveResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.acceptEnterpriseAddendum =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/AcceptEnterpriseAddendum',
      request,
      metadata || {},
      methodDescriptor_Ommuse_AcceptEnterpriseAddendum);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.UpdateLastActiveRequest,
 *   !proto.UpdateLastActiveResponse>}
 */
const methodDescriptor_Ommuse_CheckEnterpriseAddendum = new grpc.web.MethodDescriptor(
  '/Ommuse/CheckEnterpriseAddendum',
  grpc.web.MethodType.UNARY,
  proto.UpdateLastActiveRequest,
  proto.UpdateLastActiveResponse,
  /**
   * @param {!proto.UpdateLastActiveRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.UpdateLastActiveResponse.deserializeBinary
);


/**
 * @param {!proto.UpdateLastActiveRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.UpdateLastActiveResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.UpdateLastActiveResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.checkEnterpriseAddendum =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/CheckEnterpriseAddendum',
      request,
      metadata || {},
      methodDescriptor_Ommuse_CheckEnterpriseAddendum,
      callback);
};


/**
 * @param {!proto.UpdateLastActiveRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.UpdateLastActiveResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.checkEnterpriseAddendum =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/CheckEnterpriseAddendum',
      request,
      metadata || {},
      methodDescriptor_Ommuse_CheckEnterpriseAddendum);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetPendingEnterpriseInvitesRequest,
 *   !proto.GetPendingEnterpriseInvitesResponse>}
 */
const methodDescriptor_Ommuse_GetPendingEnterpriseInvites = new grpc.web.MethodDescriptor(
  '/Ommuse/GetPendingEnterpriseInvites',
  grpc.web.MethodType.UNARY,
  proto.GetPendingEnterpriseInvitesRequest,
  proto.GetPendingEnterpriseInvitesResponse,
  /**
   * @param {!proto.GetPendingEnterpriseInvitesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetPendingEnterpriseInvitesResponse.deserializeBinary
);


/**
 * @param {!proto.GetPendingEnterpriseInvitesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetPendingEnterpriseInvitesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetPendingEnterpriseInvitesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getPendingEnterpriseInvites =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetPendingEnterpriseInvites',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetPendingEnterpriseInvites,
      callback);
};


/**
 * @param {!proto.GetPendingEnterpriseInvitesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetPendingEnterpriseInvitesResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getPendingEnterpriseInvites =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetPendingEnterpriseInvites',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetPendingEnterpriseInvites);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetInvitationPendingUsersForEnterpriseRequest,
 *   !proto.GetInvitationPendingUsersForEnterpriseResponse>}
 */
const methodDescriptor_Ommuse_GetInvitationPendingUsersForEnterprise = new grpc.web.MethodDescriptor(
  '/Ommuse/GetInvitationPendingUsersForEnterprise',
  grpc.web.MethodType.UNARY,
  proto.GetInvitationPendingUsersForEnterpriseRequest,
  proto.GetInvitationPendingUsersForEnterpriseResponse,
  /**
   * @param {!proto.GetInvitationPendingUsersForEnterpriseRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetInvitationPendingUsersForEnterpriseResponse.deserializeBinary
);


/**
 * @param {!proto.GetInvitationPendingUsersForEnterpriseRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetInvitationPendingUsersForEnterpriseResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetInvitationPendingUsersForEnterpriseResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getInvitationPendingUsersForEnterprise =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetInvitationPendingUsersForEnterprise',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetInvitationPendingUsersForEnterprise,
      callback);
};


/**
 * @param {!proto.GetInvitationPendingUsersForEnterpriseRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetInvitationPendingUsersForEnterpriseResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getInvitationPendingUsersForEnterprise =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetInvitationPendingUsersForEnterprise',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetInvitationPendingUsersForEnterprise);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.AddShareAnalyticsEventRequest,
 *   !proto.AddShareAnalyticsEventResponse>}
 */
const methodDescriptor_Ommuse_AddShareAnalyticsEvent = new grpc.web.MethodDescriptor(
  '/Ommuse/AddShareAnalyticsEvent',
  grpc.web.MethodType.UNARY,
  proto.AddShareAnalyticsEventRequest,
  proto.AddShareAnalyticsEventResponse,
  /**
   * @param {!proto.AddShareAnalyticsEventRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.AddShareAnalyticsEventResponse.deserializeBinary
);


/**
 * @param {!proto.AddShareAnalyticsEventRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.AddShareAnalyticsEventResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.AddShareAnalyticsEventResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.addShareAnalyticsEvent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/AddShareAnalyticsEvent',
      request,
      metadata || {},
      methodDescriptor_Ommuse_AddShareAnalyticsEvent,
      callback);
};


/**
 * @param {!proto.AddShareAnalyticsEventRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.AddShareAnalyticsEventResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.addShareAnalyticsEvent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/AddShareAnalyticsEvent',
      request,
      metadata || {},
      methodDescriptor_Ommuse_AddShareAnalyticsEvent);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.AddTimeStampCommentRequest,
 *   !proto.AddTimeStampCommentResponse>}
 */
const methodDescriptor_Ommuse_AddTimeStampComment = new grpc.web.MethodDescriptor(
  '/Ommuse/AddTimeStampComment',
  grpc.web.MethodType.UNARY,
  proto.AddTimeStampCommentRequest,
  proto.AddTimeStampCommentResponse,
  /**
   * @param {!proto.AddTimeStampCommentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.AddTimeStampCommentResponse.deserializeBinary
);


/**
 * @param {!proto.AddTimeStampCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.AddTimeStampCommentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.AddTimeStampCommentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.addTimeStampComment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/AddTimeStampComment',
      request,
      metadata || {},
      methodDescriptor_Ommuse_AddTimeStampComment,
      callback);
};


/**
 * @param {!proto.AddTimeStampCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.AddTimeStampCommentResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.addTimeStampComment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/AddTimeStampComment',
      request,
      metadata || {},
      methodDescriptor_Ommuse_AddTimeStampComment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetTrackTimeStampCommentsRequest,
 *   !proto.GetTrackTimeStampCommentsResponse>}
 */
const methodDescriptor_Ommuse_GetTrackTimeStampComments = new grpc.web.MethodDescriptor(
  '/Ommuse/GetTrackTimeStampComments',
  grpc.web.MethodType.UNARY,
  proto.GetTrackTimeStampCommentsRequest,
  proto.GetTrackTimeStampCommentsResponse,
  /**
   * @param {!proto.GetTrackTimeStampCommentsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetTrackTimeStampCommentsResponse.deserializeBinary
);


/**
 * @param {!proto.GetTrackTimeStampCommentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetTrackTimeStampCommentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetTrackTimeStampCommentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getTrackTimeStampComments =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetTrackTimeStampComments',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetTrackTimeStampComments,
      callback);
};


/**
 * @param {!proto.GetTrackTimeStampCommentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetTrackTimeStampCommentsResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getTrackTimeStampComments =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetTrackTimeStampComments',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetTrackTimeStampComments);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.IncrementEnterpriseMasteringCountRequest,
 *   !proto.IncrementEnterpriseMasteringCountResponse>}
 */
const methodDescriptor_Ommuse_IncrementEnterpriseMasteringCount = new grpc.web.MethodDescriptor(
  '/Ommuse/IncrementEnterpriseMasteringCount',
  grpc.web.MethodType.UNARY,
  proto.IncrementEnterpriseMasteringCountRequest,
  proto.IncrementEnterpriseMasteringCountResponse,
  /**
   * @param {!proto.IncrementEnterpriseMasteringCountRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.IncrementEnterpriseMasteringCountResponse.deserializeBinary
);


/**
 * @param {!proto.IncrementEnterpriseMasteringCountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.IncrementEnterpriseMasteringCountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.IncrementEnterpriseMasteringCountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.incrementEnterpriseMasteringCount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/IncrementEnterpriseMasteringCount',
      request,
      metadata || {},
      methodDescriptor_Ommuse_IncrementEnterpriseMasteringCount,
      callback);
};


/**
 * @param {!proto.IncrementEnterpriseMasteringCountRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.IncrementEnterpriseMasteringCountResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.incrementEnterpriseMasteringCount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/IncrementEnterpriseMasteringCount',
      request,
      metadata || {},
      methodDescriptor_Ommuse_IncrementEnterpriseMasteringCount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.DownloadProjectOrFolderRequest,
 *   !proto.DownloadProjectOrFolderResponse>}
 */
const methodDescriptor_Ommuse_DownloadProjectOrFolder = new grpc.web.MethodDescriptor(
  '/Ommuse/DownloadProjectOrFolder',
  grpc.web.MethodType.UNARY,
  proto.DownloadProjectOrFolderRequest,
  proto.DownloadProjectOrFolderResponse,
  /**
   * @param {!proto.DownloadProjectOrFolderRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.DownloadProjectOrFolderResponse.deserializeBinary
);


/**
 * @param {!proto.DownloadProjectOrFolderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.DownloadProjectOrFolderResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.DownloadProjectOrFolderResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.downloadProjectOrFolder =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/DownloadProjectOrFolder',
      request,
      metadata || {},
      methodDescriptor_Ommuse_DownloadProjectOrFolder,
      callback);
};


/**
 * @param {!proto.DownloadProjectOrFolderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.DownloadProjectOrFolderResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.downloadProjectOrFolder =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/DownloadProjectOrFolder',
      request,
      metadata || {},
      methodDescriptor_Ommuse_DownloadProjectOrFolder);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetDashBoardDetailsRequest,
 *   !proto.GetDashBoardDetailsResponse>}
 */
const methodDescriptor_Ommuse_GetDashBoardDetails = new grpc.web.MethodDescriptor(
  '/Ommuse/GetDashBoardDetails',
  grpc.web.MethodType.UNARY,
  proto.GetDashBoardDetailsRequest,
  proto.GetDashBoardDetailsResponse,
  /**
   * @param {!proto.GetDashBoardDetailsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetDashBoardDetailsResponse.deserializeBinary
);


/**
 * @param {!proto.GetDashBoardDetailsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetDashBoardDetailsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetDashBoardDetailsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getDashBoardDetails =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetDashBoardDetails',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetDashBoardDetails,
      callback);
};


/**
 * @param {!proto.GetDashBoardDetailsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetDashBoardDetailsResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getDashBoardDetails =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetDashBoardDetails',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetDashBoardDetails);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetDashBoardTracksRequest,
 *   !proto.GetDashBoardTracksResponse>}
 */
const methodDescriptor_Ommuse_GetDashBoardTracks = new grpc.web.MethodDescriptor(
  '/Ommuse/GetDashBoardTracks',
  grpc.web.MethodType.UNARY,
  proto.GetDashBoardTracksRequest,
  proto.GetDashBoardTracksResponse,
  /**
   * @param {!proto.GetDashBoardTracksRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetDashBoardTracksResponse.deserializeBinary
);


/**
 * @param {!proto.GetDashBoardTracksRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetDashBoardTracksResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetDashBoardTracksResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getDashBoardTracks =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetDashBoardTracks',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetDashBoardTracks,
      callback);
};


/**
 * @param {!proto.GetDashBoardTracksRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetDashBoardTracksResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getDashBoardTracks =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetDashBoardTracks',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetDashBoardTracks);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetDashBoardUsersRequest,
 *   !proto.GetDashBoardUsersResponse>}
 */
const methodDescriptor_Ommuse_GetDashBoardUsers = new grpc.web.MethodDescriptor(
  '/Ommuse/GetDashBoardUsers',
  grpc.web.MethodType.UNARY,
  proto.GetDashBoardUsersRequest,
  proto.GetDashBoardUsersResponse,
  /**
   * @param {!proto.GetDashBoardUsersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetDashBoardUsersResponse.deserializeBinary
);


/**
 * @param {!proto.GetDashBoardUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetDashBoardUsersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetDashBoardUsersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getDashBoardUsers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetDashBoardUsers',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetDashBoardUsers,
      callback);
};


/**
 * @param {!proto.GetDashBoardUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetDashBoardUsersResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getDashBoardUsers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetDashBoardUsers',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetDashBoardUsers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetDashBoardProjectFilesRequest,
 *   !proto.GetDashBoardProjectFilesResponse>}
 */
const methodDescriptor_Ommuse_GetDashBoardProjectFiles = new grpc.web.MethodDescriptor(
  '/Ommuse/GetDashBoardProjectFiles',
  grpc.web.MethodType.UNARY,
  proto.GetDashBoardProjectFilesRequest,
  proto.GetDashBoardProjectFilesResponse,
  /**
   * @param {!proto.GetDashBoardProjectFilesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetDashBoardProjectFilesResponse.deserializeBinary
);


/**
 * @param {!proto.GetDashBoardProjectFilesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetDashBoardProjectFilesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetDashBoardProjectFilesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getDashBoardProjectFiles =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetDashBoardProjectFiles',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetDashBoardProjectFiles,
      callback);
};


/**
 * @param {!proto.GetDashBoardProjectFilesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetDashBoardProjectFilesResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getDashBoardProjectFiles =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetDashBoardProjectFiles',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetDashBoardProjectFiles);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetDashBoardProjectsRequest,
 *   !proto.GetDashBoardProjectsResponse>}
 */
const methodDescriptor_Ommuse_GetDashBoardProjects = new grpc.web.MethodDescriptor(
  '/Ommuse/GetDashBoardProjects',
  grpc.web.MethodType.UNARY,
  proto.GetDashBoardProjectsRequest,
  proto.GetDashBoardProjectsResponse,
  /**
   * @param {!proto.GetDashBoardProjectsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetDashBoardProjectsResponse.deserializeBinary
);


/**
 * @param {!proto.GetDashBoardProjectsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetDashBoardProjectsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetDashBoardProjectsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getDashBoardProjects =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetDashBoardProjects',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetDashBoardProjects,
      callback);
};


/**
 * @param {!proto.GetDashBoardProjectsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetDashBoardProjectsResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getDashBoardProjects =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetDashBoardProjects',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetDashBoardProjects);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetDashBoardPublishedTracksRequest,
 *   !proto.GetDashBoardPublishedTracksResponse>}
 */
const methodDescriptor_Ommuse_GetDashBoardPublishedTracks = new grpc.web.MethodDescriptor(
  '/Ommuse/GetDashBoardPublishedTracks',
  grpc.web.MethodType.UNARY,
  proto.GetDashBoardPublishedTracksRequest,
  proto.GetDashBoardPublishedTracksResponse,
  /**
   * @param {!proto.GetDashBoardPublishedTracksRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetDashBoardPublishedTracksResponse.deserializeBinary
);


/**
 * @param {!proto.GetDashBoardPublishedTracksRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetDashBoardPublishedTracksResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetDashBoardPublishedTracksResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getDashBoardPublishedTracks =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetDashBoardPublishedTracks',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetDashBoardPublishedTracks,
      callback);
};


/**
 * @param {!proto.GetDashBoardPublishedTracksRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetDashBoardPublishedTracksResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getDashBoardPublishedTracks =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetDashBoardPublishedTracks',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetDashBoardPublishedTracks);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.LinkFoldersToProjectRequest,
 *   !proto.LinkFoldersToProjectResponse>}
 */
const methodDescriptor_Ommuse_LinkFoldersToProject = new grpc.web.MethodDescriptor(
  '/Ommuse/LinkFoldersToProject',
  grpc.web.MethodType.UNARY,
  proto.LinkFoldersToProjectRequest,
  proto.LinkFoldersToProjectResponse,
  /**
   * @param {!proto.LinkFoldersToProjectRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.LinkFoldersToProjectResponse.deserializeBinary
);


/**
 * @param {!proto.LinkFoldersToProjectRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.LinkFoldersToProjectResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.LinkFoldersToProjectResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.linkFoldersToProject =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/LinkFoldersToProject',
      request,
      metadata || {},
      methodDescriptor_Ommuse_LinkFoldersToProject,
      callback);
};


/**
 * @param {!proto.LinkFoldersToProjectRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.LinkFoldersToProjectResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.linkFoldersToProject =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/LinkFoldersToProject',
      request,
      metadata || {},
      methodDescriptor_Ommuse_LinkFoldersToProject);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.ConvertFolderToProjectRequest,
 *   !proto.ConvertFolderToProjectResponse>}
 */
const methodDescriptor_Ommuse_ConvertFolderToProject = new grpc.web.MethodDescriptor(
  '/Ommuse/ConvertFolderToProject',
  grpc.web.MethodType.UNARY,
  proto.ConvertFolderToProjectRequest,
  proto.ConvertFolderToProjectResponse,
  /**
   * @param {!proto.ConvertFolderToProjectRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.ConvertFolderToProjectResponse.deserializeBinary
);


/**
 * @param {!proto.ConvertFolderToProjectRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.ConvertFolderToProjectResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.ConvertFolderToProjectResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.convertFolderToProject =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/ConvertFolderToProject',
      request,
      metadata || {},
      methodDescriptor_Ommuse_ConvertFolderToProject,
      callback);
};


/**
 * @param {!proto.ConvertFolderToProjectRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.ConvertFolderToProjectResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.convertFolderToProject =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/ConvertFolderToProject',
      request,
      metadata || {},
      methodDescriptor_Ommuse_ConvertFolderToProject);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetTotalTracksAndFilesCountRequest,
 *   !proto.GetTotalTracksAndFilesCountResponse>}
 */
const methodDescriptor_Ommuse_GetTotalTracksAndFilesCount = new grpc.web.MethodDescriptor(
  '/Ommuse/GetTotalTracksAndFilesCount',
  grpc.web.MethodType.UNARY,
  proto.GetTotalTracksAndFilesCountRequest,
  proto.GetTotalTracksAndFilesCountResponse,
  /**
   * @param {!proto.GetTotalTracksAndFilesCountRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetTotalTracksAndFilesCountResponse.deserializeBinary
);


/**
 * @param {!proto.GetTotalTracksAndFilesCountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetTotalTracksAndFilesCountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetTotalTracksAndFilesCountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getTotalTracksAndFilesCount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetTotalTracksAndFilesCount',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetTotalTracksAndFilesCount,
      callback);
};


/**
 * @param {!proto.GetTotalTracksAndFilesCountRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetTotalTracksAndFilesCountResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getTotalTracksAndFilesCount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetTotalTracksAndFilesCount',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetTotalTracksAndFilesCount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.AddEnterpriseAccountRequest,
 *   !proto.AddEnterpriseAccountResponse>}
 */
const methodDescriptor_Ommuse_AddEnterpriseAccount = new grpc.web.MethodDescriptor(
  '/Ommuse/AddEnterpriseAccount',
  grpc.web.MethodType.UNARY,
  proto.AddEnterpriseAccountRequest,
  proto.AddEnterpriseAccountResponse,
  /**
   * @param {!proto.AddEnterpriseAccountRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.AddEnterpriseAccountResponse.deserializeBinary
);


/**
 * @param {!proto.AddEnterpriseAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.AddEnterpriseAccountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.AddEnterpriseAccountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.addEnterpriseAccount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/AddEnterpriseAccount',
      request,
      metadata || {},
      methodDescriptor_Ommuse_AddEnterpriseAccount,
      callback);
};


/**
 * @param {!proto.AddEnterpriseAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.AddEnterpriseAccountResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.addEnterpriseAccount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/AddEnterpriseAccount',
      request,
      metadata || {},
      methodDescriptor_Ommuse_AddEnterpriseAccount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetFolderArtworkRequest,
 *   !proto.GetFolderArtworkResponse>}
 */
const methodDescriptor_Ommuse_GetFolderArtwork = new grpc.web.MethodDescriptor(
  '/Ommuse/GetFolderArtwork',
  grpc.web.MethodType.UNARY,
  proto.GetFolderArtworkRequest,
  proto.GetFolderArtworkResponse,
  /**
   * @param {!proto.GetFolderArtworkRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetFolderArtworkResponse.deserializeBinary
);


/**
 * @param {!proto.GetFolderArtworkRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetFolderArtworkResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetFolderArtworkResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getFolderArtwork =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetFolderArtwork',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetFolderArtwork,
      callback);
};


/**
 * @param {!proto.GetFolderArtworkRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetFolderArtworkResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getFolderArtwork =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetFolderArtwork',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetFolderArtwork);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.GetAssetCountRequest,
 *   !proto.GetAssetCountResponse>}
 */
const methodDescriptor_Ommuse_GetAssetCount = new grpc.web.MethodDescriptor(
  '/Ommuse/GetAssetCount',
  grpc.web.MethodType.UNARY,
  proto.GetAssetCountRequest,
  proto.GetAssetCountResponse,
  /**
   * @param {!proto.GetAssetCountRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.GetAssetCountResponse.deserializeBinary
);


/**
 * @param {!proto.GetAssetCountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.GetAssetCountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.GetAssetCountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.OmmuseClient.prototype.getAssetCount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Ommuse/GetAssetCount',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetAssetCount,
      callback);
};


/**
 * @param {!proto.GetAssetCountRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.GetAssetCountResponse>}
 *     Promise that resolves to the response
 */
proto.OmmusePromiseClient.prototype.getAssetCount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Ommuse/GetAssetCount',
      request,
      metadata || {},
      methodDescriptor_Ommuse_GetAssetCount);
};


module.exports = proto;

